import { camelizeKeys, decamelizeKeys } from 'xcase'

class BaseModel {
  constructor(options = {}, defaults = {}, camelize = true) {
    this.defaults = defaults
    this.camelize = camelize

    if (this.camelize) options = camelizeKeys(options)

    let opts = Object.assign({}, defaults, options)

    // Assign options to instance data (using only property names contained
    // in defaults object to avoid copying properties we don't want)
    Object.keys(defaults).forEach(prop => {
      this[prop] = opts[prop]
    })
  }

  set(options) {
    if (this.camelize) options = camelizeKeys(options)

    Object.keys(this.defaults).forEach(prop => {
      this[prop] = options[prop]
    })
  }

  toSnakeCase() {
    return decamelizeKeys(this)
  }
}

export { BaseModel as default }
